import { FormName } from '@topconagriculture/feed-types';

import { DriverPermission } from '../../../store/entities/driverPermissions/driverPermissions.types';
import { APIFactoryParams } from '../apiManager';

export const DriverPermissionsFactory = ({ HTTPBase, config }: APIFactoryParams) => ({
  getDriverPermissions: () => HTTPBase.get(`farm/${config.farmId}/driverpermissions`).then((res) => res.data),
  updateDriverPermissions: (payload: Partial<DriverPermission>[], formName: FormName) =>
    HTTPBase.patch(`farm/${config.farmId}/driverpermissions`, payload, { headers: { formName } }).then(
      (res) => res.data,
    ),
});
